import "./UniversalLanding.css";
import React from "react";
import MobxView from "higher-order/MobxView";
import PropTypes from "prop-types";
import Propulator from "higher-order/Propulator";
import RecaptchaStore from "shared/models/recaptcha/RecaptchaStore";
import { observer } from "mobx-react";
import autobind from "autobind-decorator";
import ResendInvitationStore from "session/models/ResendInvitationStore";
import SessionPageContent from "session/components/SessionPageContent";
import SessionPageLogo from "../components/SessionPageLogo";
import CustomForm from "gradifui/components/form/CustomForm";
import CustomInput from "gradifui/components/form/CustomInput";
import CustomSubmit from "gradifui/components/form/CustomSubmit";
import ContentItem from "shared/components/cms/ContentItem";
import classNames from "classnames";
import Mouseflow from "shared/components/Mouseflow";
import Recaptcha from "react-grecaptcha";

@observer
class UniversalLanding extends React.Component {
    static propTypes = {
        dispatcher: PropTypes.object.isRequired
    };

    componentDidMount() {
        Mouseflow();
    }

    @autobind
    handleSave(e) {
        e.preventDefault(); // Cancel foreground form POST
        this.props.dispatcher.emit("RESEND_INVITATION");
    }

    @autobind
    recaptchaCallback(e) {
        this.props.dispatcher.emit("SET_CAPTCHA_TOKEN", {
            response: e,
            formModel: this.props.resendInvitationForm
        });
    }

    @autobind
    recaptchaExpiredCallback(_) {
        this.props.dispatcher.emit("CLEAR_CAPTCHA_TOKEN", {
            formModel: this.props.resendInvitationForm
        });
    }

    render() {
        return (
            <SessionPageContent className={classNames("universal-landing", { "invitation-was-sent": this.props.invitationWasSent })}>
                {!this.props.invitationWasSent &&
                    <React.Fragment>
                        <SessionPageLogo baseAddress={this.props.session?.baseAddress} />
                        <div className="main">
                            <div className="form panel">
                                <ContentItem className="page-header" contentKey="pageHeader" tag="h1" />
                                <ContentItem className="page-subheader" contentKey="pageSubheader" />
                                <CustomForm name="universalLandingForm" form={this.props.resendInvitationForm} onSubmit={this.handleSave} showFormLevelErrors={false}>
                                    <CustomInput fieldName="email" placeholder="Work Email Address" className="no-mouseflow" />
                                    <Recaptcha
                                        className="recaptcha-component"
                                        sitekey={this.props.recaptchaSiteKey}
                                        callback={this.recaptchaCallback}
                                        expiredCallback={this.recaptchaExpiredCallback}
                                    />
                                    <CustomSubmit disabled={!this.props.hasCaptchaToken} value="Get Started Now" />
                                </CustomForm>
                                <section className="login-section">
                                    <ContentItem tag="h1" contentKey="loginHeader" className="login-header" />
                                    <a className="login-link" href={this.props.session.loginPath}>Log in</a>
                                </section>
                            </div>
                        </div>
                    </React.Fragment>
                }
                {this.props.invitationWasSent &&
                    <React.Fragment>
                        <div className="main confirmation">
                            <div className= "confirm-header panel">
                                <ContentItem contentKey="invitationHeader" tag="h1" />
                            </div>
                            <div className="confirm-content panel">
                                <ContentItem contentKey="invitationWasSent" className="invitation-was-sent" />
                            </div>
                        </div>
                    </React.Fragment>
                }
            </SessionPageContent>
        );
    }
}

const propulatedView = Propulator(UniversalLanding, {
    resendInvitationStore: [
        "invitationWasSent",
        "resendInvitationForm"
    ],
    sessionStore: ["session"],
    recaptchaStore: [
        "hasCaptchaToken",
        "recaptchaSiteKey"
    ]
});

export default MobxView(propulatedView, {
    recaptchaStore: RecaptchaStore,
    resendInvitationStore: ResendInvitationStore
});
